namespace $.$$ {
	export class $shm_hotkey_editor extends $.$shm_hotkey_editor {
		popup_content() { return this.showed() ? [ this.Bubble() ] : [] }
		override bubble_content() { return [ this.Message(), ... this.status() ? [ this.Status() ] : [], this.Configure(), ... this.remove_enabled() ? [ this.Remove() ] : [] ] }
		configure_title() { return 'Изменить клавишу назначения' }
		configure_hint() { return `Сейчас: ${ this.activation_label() }` }
	}
}
